import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import qs from 'query-string';

import { setIsPlicCheckoutFlag as setIsPlicCheckoutFlagAction } from '../../../actions/discover-album-folder';

const WithSetPlicCheckoutFlag = WrappedComponent =>
  class extends Component {
    static propTypes = {
      location: PropTypes.shape({
        search: PropTypes.string,
      }).isRequired,
      onSetPlicCheckout: PropTypes.func.isRequired,
    };

    constructor(props) {
      super(props);

      const { location, onSetPlicCheckout } = this.props;

      const { plic_yearbook_checkout: isPlicCheckout } = qs.parse(
        location.search,
      );

      if (typeof isPlicCheckout !== 'undefined') {
        onSetPlicCheckout(!!isPlicCheckout);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  albumFolderId: discoverAlbumFolder.albumFolderId,
});

const mapDispatchToProps = dispatch => ({
  onSetPlicCheckout: flag => dispatch(setIsPlicCheckoutFlagAction(flag)),
});

export { WithSetPlicCheckoutFlag };

export default WrappedComponent => {
  return compose(
    connect(mapStateToProps, mapDispatchToProps),
    WithSetPlicCheckoutFlag,
  )(WrappedComponent);
};
